export default function(context) {
  if (
    context &&
    context.route &&
    context.route.name &&
    (context.route.name.startsWith('maintenance-') ||
      context.route.name === 'overview' ||
      context.route.name === 'demo')
  ) {
    context.store.dispatch('maintenance/setTimePeriodHourBoundaries')
  }
}
